import React from 'react';
import Switch from 'react-switch';
import { useCompany } from "../Commoncontext/CompanyContext";

function ToggleSwitch({ checked, onChange, label, disabled }) {
  const { companyColor } = useCompany();
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
      <span style={{ marginRight: '10px', flex: 1 }}>
        {typeof label === "string" ? label : label}
      </span>
      <Switch 
        onChange={onChange} 
        checked={checked} 
        handleDiameter={28}
        offColor="#888"
        onColor={companyColor}
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={48}
        disabled={disabled} // Lisätty disabled-attribuutti
      />
    </div>
  );
}

export default ToggleSwitch;
